import { createContext, useContext, ReactNode } from 'react';
import { useOdometer, OdometerReading } from '../hooks/useOdometer';

interface OdometerData {
  readings: OdometerReading[];
  currentReading: number | null;
  lastLocation: { lat: number; lng: number } | null;
  totalMiles: number;
}

interface OdometerContextType {
  odometerData: OdometerData;
  isLoading: boolean;
  error: string | null;
  startDayOdometer: (reading: number, retroactiveTimestamp?: Date) => Promise<void>;
  recordStoreArrival: (storeId: number, storeName: string, reading: number, calculatedReading?: number) => Promise<void>;
  recordStoreDeparture: (storeId: number, storeName: string, reading: number) => Promise<void>;
  endDayOdometer: (reading: number) => Promise<void>;
  calculateExpectedOdometer: (targetLat: number, targetLng: number) => number | null;
  resetOdometer: () => void;
}

const OdometerContext = createContext<OdometerContextType | null>(null);

export function OdometerProvider({ children }: { children: ReactNode }) {
  const odometer = useOdometer();

  return (
    <OdometerContext.Provider value={odometer}>
      {children}
    </OdometerContext.Provider>
  );
}

export function useOdometerContext() {
  const context = useContext(OdometerContext);
  if (!context) {
    throw new Error('useOdometerContext must be used within an OdometerProvider');
  }
  return context;
}
